/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */
import type { Geometry } from 'geojson';
import type { EDRInstance, EdrParameter } from '@opengeoweb/shared';

export interface FeaturesFromBE {
  id: string;
  type: string;
  geometry: Geometry;
  properties: {
    datetime: string;
    detail: string;
    name: string;
  };
}
export interface LocationsResponseFromBE {
  features: FeaturesFromBE[];
  type: string;
}

// Sounding EDR-to-plot types
export interface SoundingFeatureProperties {
  time: string;
  temp: number;
  dewpoint: number;
  pressure: number;
  windSpeed: number;
  windDirection: number;
}

export interface SoundingFeature {
  type: 'Feature';
  geometry: Geometry;
  properties: SoundingFeatureProperties;
}

export type SoundingsInstance = EDRInstance;

export interface SoundingsInstances {
  instances: SoundingsInstance[];
}

export interface CollectionDetails extends EDRInstance {
  parameter_names: Record<string, EdrParameter>;
}

export const soundingDiagrams = ['SKEWT', 'BIJVOET', 'EMAGRAM'] as const;
export type SoundingDiagramType = (typeof soundingDiagrams)[number];
